import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const TaskLinearTable = ({
    handleDelete,
    paginatedTasks,
    getShortDescription,
    handleEdit,
    selectedDateTasks,
    handleChangePage,
    rowsPerPage,
    handleChangeRowsPerPage,
    page
}) => {
    return(
        <>
        <TableContainer component={Paper}>
            <Table
            sx={{ minWidth: 650 }}
            aria-label="task list table"
            >
            <TableHead>
                <TableRow>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                >
                    Type of Task
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Assigned To
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Due Date
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Status
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Priority
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Description
                </TableCell>
                <TableCell
                    className="styled-table-heading"
                    sx={{ fontWeight: "bold" }}
                    align="left"
                >
                    Action
                </TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {paginatedTasks.map((task) => (
                    <TableRow
                    key={task.id}
                    className="styled-table-row"
                    >
                    <TableCell align="left">
                        {task.taskType}
                    </TableCell>
                    <TableCell align="left">
                        {task.assignedToName}
                    </TableCell>
                    <TableCell align="left">
                        {(() => {
                        const date = new Date(task.dueDate);
                        const mm = String(
                            date.getMonth() + 1
                        ).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(
                            2,
                            "0"
                        );
                        const yyyy = date.getFullYear();
                        return `${mm}-${dd}-${yyyy}`;
                        })()}
                    </TableCell>
                    <TableCell align="left">{task.status}</TableCell>
                    <TableCell align="left">
                        {task.priority}
                    </TableCell>
                    <TableCell align="left">
                        <Tooltip
                        title={task.taskDescription}
                        arrow
                        placement="top"
                        componentsProps={{
                            tooltip: {
                            sx: {
                                backgroundColor: "white",
                                color: "black",
                                boxShadow: 1,
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                fontWeight: "bold",
                            },
                            },

                        arrow: {
                            sx: {
                                color: "white",
                            },
                            },
                        }}
                        >
                        <span>
                            {getShortDescription(task.taskDescription)}
                        </span>
                        </Tooltip>
                    </TableCell>

                    <TableCell align="left" sx={{ pl: 0 }}>
                        <IconButton
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleEdit(task);
                        }}
                        sx={{ ml: -1 }}
                        >
                        <EditIcon />
                        </IconButton>
                        <IconButton
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleDelete(task.id);
                        }}
                        >
                        <DeleteIcon />
                        </IconButton>
                    </TableCell>
                    </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            component="div"
            count={selectedDateTasks.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[3, 5, 10, 25, 50, 100]}
        />
    </>
    )     
}
export default TaskLinearTable;